import * as Yup from 'yup';

/**
 * The triple is required whenever a tunnel is in play. `useSSH` is that single
 * flag — peering fills the same three fields rather than setting a second one
 * (mode is derived from `sshUser`), so there is nothing else to key on. Excusing
 * the fields under peering would let a team submit the flag with no host, which
 * the backend validator rejects.
 */
export function requiredWhenTunnelled() {
  return Yup.string().when('useSSH', {
    is: (useSSH: unknown) => !!useSSH,
    then: () => Yup.string().required(),
    otherwise: () => Yup.string().nullable()
  });
}

export function getSSHConfigValidationSchema() {
  return {
    useSSH: Yup.boolean(),
    sshIp: requiredWhenTunnelled(),
    sshPort: requiredWhenTunnelled(),
    sshUser: requiredWhenTunnelled()
  };
}
